import React, { useEffect, useRef, useState } from "react";
import { Download, FileText } from "lucide-react";

export const DOW_DISCLOSURES_PDF = "/docs/dow-disclosures.pdf";

export function DisclosureDocs({ height = "max-h-[75vh]", onReadAll, fileName = "Diocese-of-Wilmington-Disclosures.pdf" }: { height?: string; onReadAll?: () => void; fileName?: string }) {
  const box = useRef<HTMLDivElement>(null);
  const [lastLoaded, setLastLoaded] = useState(false);
  const check = () => {
    const el = box.current;
    if (el && onReadAll && lastLoaded && el.scrollTop + el.clientHeight >= el.scrollHeight - 40) onReadAll();
  };
  useEffect(() => { check(); });
  return (
    <div className="card-soft overflow-hidden" data-testid="dow-disclosures-viewer">
      <div className="flex flex-wrap items-center justify-between gap-3 border-b border-slate-100 px-5 py-3">
        <span className="flex items-center gap-2 text-sm font-semibold text-[#1B365D]"><FileText className="h-4 w-4" /> All Disclosures (6 pages)</span>
        <a href={DOW_DISCLOSURES_PDF} download={fileName} className="btn-secondary btn-sm" data-testid="dow-disclosures-download-button"><Download className="h-4 w-4" /> Download PDF</a>
      </div>
      <div ref={box} onScroll={check} className={`${height} space-y-4 overflow-y-auto bg-[#F1EFEA] p-3 sm:p-5`} data-testid="dow-disclosures-pages">
        {[1, 2, 3, 4, 5, 6].map((n) => (
          <img key={n} src={`/docs/dow-p-${n}.png`} alt={`Disclosures page ${n} of 6`} loading={n > 1 ? "lazy" : "eager"} onLoad={n === 6 ? () => setLastLoaded(true) : undefined} className="mx-auto w-full max-w-3xl rounded-lg bg-white shadow-sm" data-testid={`dow-disclosures-page-${n}`} />
        ))}
      </div>
    </div>
  );
}
